import { Dropdown, Grid, Icon, Popup } from 'semantic-ui-react';
import React, { useContext, useState } from 'react';
import { LinkedAccount } from 'dyl-components';
import { PhoneUtil, StringUtils } from 'utils';
import { Link } from 'react-router-dom';

import InfluenceField from './InfluenceField';

import { ContactContext } from 'shared/context/ContactProvider';
import { useSelector } from 'react-redux';
import { ActivityPopup } from 'shared/forms/NewActivity';
import TextIcon from 'shared/TextIcon';
import RestrictedView from 'shared/RestrictedView';
import { USER_PERMISSIONS } from 'dyl-components';

export default function AccountContact({
    contact,
    contactBeingEdited,
    account_id,
    onCancelEdit,
    contactColumnWidth,
    onUnpin,
    isSidePanelOpen,
    pinOptions,
    onReplacePinnedContact,
    isReadingContactsForPinning,
    onEdit,
    onClickToDial,
    onText,
    assignees,
}) {
    const { first_name, last_name, id, influence, module_summary, primary_phone, primary_email, job_title = '' } = contact;
    const name = `${first_name} ${last_name}`;

    const userPhoneCreds = useSelector(state => state?.officeView?.creds)
    const [openActivityForm, setOpenActivityForm] = useState(false);
    const isPhoneSystemSupported = PhoneUtil.isPhoneSystemSupported(userPhoneCreds);

    const { onOpenModal } = useContext(ContactContext);

    const onOpenActivityForm = (type) => {
        setOpenActivityForm(type);
    }

    const onCloseActivityForm = () => {
        setOpenActivityForm('');
    }

    return (
        <Grid.Row key={id} verticalAlign='middle' columns='equal'>
            <Grid.Column verticalAlign='middle' width={contactColumnWidth}>
                <Grid columns='equal' verticalAlign='middle'>
                    <Grid.Column width={1}>
                        <Popup
                            trigger={<Icon onClick={() => { onUnpin(id); }} color='primary' link className='fas thumbtack' />}
                            content='Unpin'
                            inverted />
                    </Grid.Column>
                    <Grid.Column {...(isSidePanelOpen ? { width: contactColumnWidth } : {})}>
                        <RestrictedView type="disabled" userPermission={USER_PERMISSIONS.ACCOUNT_EDIT} userRestrict assignmentIds={[(assignees?.owner_id || 0), (assignees?.coowner_id || 0)]}>
                            <Dropdown
                                placeholder='Pin a Contact'
                                selectOnBlur={false}
                                selection
                                options={pinOptions}
                                value={id}
                                onChange={(_, { value: contact_id }) => {
                                    if (contact_id) {
                                        if (contact_id !== id) {
                                            onReplacePinnedContact(id, contact_id);
                                        }
                                    } else {
                                        onUnpin(id);
                                    }
                                }}
                                compact
                                text={(
                                    <LinkedAccount
                                        account={name}
                                        maxWidth={'8.25em'}
                                        subtitle={job_title}
                                        popup
                                        linkToAccount={
                                        <RestrictedView type="link" userPermission={USER_PERMISSIONS.CONTACTS_VIEW} userRestrict assignmentIds={[(contact?.owner_id || 0), (contact?.coowner_id || 0)]}>
                                            <Link onClick={e => { e.stopPropagation(); }} target={'_blank'} to={`/contact/${id}`}>{name}</Link>
                                        </RestrictedView>
                                        } 
                                    />
                                )}
                                clearable
                                style={{ width: '15em' }}
                                loading={isReadingContactsForPinning} />
                            </RestrictedView>
                    </Grid.Column>
                    <Grid.Column>
                        {isPhoneSystemSupported ?
                            <Icon disabled={!primary_phone?.phone} link color='primary' onClick={() => onClickToDial(contact)} className='fas fa-phone' /> :
                            <ActivityPopup
                                trigger={
                                    <Icon link color='primary' className='fas fa-phone' />
                                }
                                activityProps={{
                                    hideActivitySelection: true,
                                    contact: { id:contact?.id },
                                    isContact: true
                                }}
                                open={openActivityForm === 'call'}
                                onOpen={() => onOpenActivityForm('call')}
                                onClose={onCloseActivityForm}
                            />}
                        <TextIcon 
                            account_id={account_id}
                            contact_id={id}
                            isActivityFormOpen={openActivityForm === 'text'}
                            onCloseActivityForm={onCloseActivityForm}
                            onOpenActivityForm={() => {onOpenActivityForm('text')}}
                            onOpenTextModal={onText}
                            phone={primary_phone?.phone}
                            primary
                        />
                        <Icon disabled={!primary_email?.email} link color='primary' className='fas fa-envelope'
                            onClick={() => {
                                onOpenModal('email', id);
                            }}
                        />
                        <RestrictedView type="disabled" userPermission={USER_PERMISSIONS.CONTACTS_ADD}>
                            <Icon link color='primary' className='fa-sharp fa-solid fa-pen-clip'
                                onClick={() => {
                                    onOpenModal('note', contact);
                                }}
                            />
                        </RestrictedView>
                    </Grid.Column>
                </Grid>
            </Grid.Column>
            <Grid.Column>
                <InfluenceField
                    account_id={account_id}
                    contactBeingEdited={contactBeingEdited}
                    id={id}
                    influence={influence}
                    onCancelEdit={onCancelEdit}
                    onEdit={onEdit}
                    recordType="account"
                    assignees={assignees}
                />
            </Grid.Column>
            <Grid.Column>
                {module_summary ? `${StringUtils.capitalize(module_summary.account_stage)}-${module_summary.pipeline_stage_name}` : ''}
            </Grid.Column>
        </Grid.Row>
    );
}

